define('presentation/settings/liveReceptionistScripts/validators/associateLiveReceptionistScriptViewModelValidator',['presentation/common/validation/commonValidator',
    'presentation/common/validation/validationRule',
    'common/uniqueId/guidUtil'
], function () {
    return function () {
        const self = this;

        const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
        const ValidationRulesConstructor = require('presentation/common/validation/validationRule');
        const _guidUtil = require('common/uniqueId/guidUtil');

        let _commonValidator = null;

        self.registerViewModel = (associateLiveReceptionistScriptViewModel, associateLiveReceptionistScriptFacade) => {
            _commonValidator = new CommonValidatorConstructor(associateLiveReceptionistScriptViewModel);

            const validationRules = new ValidationRulesConstructor();

            validationRules.field("portalScriptId")
                .addValidationI18n(_commonValidator.isStringWithValue, 'associateLiveReceptionistScript:portalScriptIdRequired')
                .addValidationI18n(_validatePortalScriptId, 'associateLiveReceptionistScript:portalScriptIdInvalid');

            _commonValidator.useManualValidation();
            _commonValidator.setValidationRules(validationRules);
        };

        self.validate = () => {
            return _commonValidator.validate();
        };

        const _validatePortalScriptId = (portalScriptId) => {
            return _guidUtil.isGuid(portalScriptId);
        };
    };
});
